module.exports = __webpack_public_path__ + "static/media/Rubik-Black.99e5b40f.ttf";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@shoutem/ui/fonts/Rubik-Black.ttf
// module id = 1258
// module chunks = 0